import { GroupCode } from "../Session/GroupCode";
import { Session } from "../Session/Session";
import { useAppStateContext } from "hooks/useAppState/useAppState";

export const Home = ({ timeout }) => {
  const { sessionAuthType } = useAppStateContext();
  if (!sessionAuthType) return <GroupCode timeout={timeout} />
  return <Session />;
};
